import React from 'react'
import FormEvents from '../components/FormEvents'
import hipladeTemplate from '../../common/template'

function EventsForm() {
  return <FormEvents />
}

export default hipladeTemplate(EventsForm)
